import React, { useState } from "react";
import ForgetPassModal from "../../utils/modals/ForgetPassModal";
import Logo from "../../../assets/img/Logo.svg";
import { useValidator } from "react-joi";
// ======= Bootstrp Components=======
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
// components
import { joiErrorMessage } from "../../utils/extra/joiErrorMessage";
import { forgetPassSetData } from "../../../context/api/forget-pass/forgetPassSetData";
import Message from "../../utils/modals/Message";
import { forgetPassSchema } from "../../joi/forgetPassSchema";
const ForgetPass = ({ lang }) => {
  const data = require(`../../../translate/${
    lang === "AR" ? "arabic" : "english"
  }/data.json`);

  const initialVerifyState = {
    token: String,
    otp: String,
    email: String,
    isShow: false,
  };
  const initialMessageResState = {
    success: Boolean,
    message: String,
    isShow: false,
  };

  const [verifyModal, setVerifyModal] = useState(initialVerifyState);

  const [btnLoader, setBtnLoader] = useState(false);
  const [messageResponse, setMessageResponse] = useState(
    initialMessageResState
  );
  const { state, setData, setExplicitField, validate } = useValidator(
    forgetPassSchema(lang).schema
  );

  const updateEmail = (e) => {
    // react < v17
    e.persist();

    setData((old) => ({
      ...old,
      email: e.target.value,
    }));
  };

  const postData = (e) => {
    e.preventDefault();
    const credintial = {
      email: state.$data.email,
    };

    if (state.$all_source_errors.length < 1) {
      setBtnLoader(() => true);
      return forgetPassSetData(
        lang,
        credintial,
        setMessageResponse,
        setBtnLoader,
        setVerifyModal
      );
    }
  };

  return (
    <>
      <Message
        messageResponse={messageResponse}
        close={() => setMessageResponse(initialMessageResState)}
        lang={lang}
      />

      <div className="forget_pass_p d-flex align-items-center justify-content-center">
        <ForgetPassModal
          show={verifyModal}
          onHide={() => setVerifyModal(initialVerifyState)}
          lang={lang}
          setMessageResponse={setMessageResponse}
          token={verifyModal.token}
        />
        <div className="forget_pass_p-form d-flex flex-column align-items-center">
          <img src={Logo} width={250} alt="Amar" className="my-5" />
          <Form
            className="w-100 px-4 pb-4"
            dir={lang === "AR" ? "rtl" : "ltr"}
            onSubmit={(e) => {
              validate();
              postData(e);
            }}
          >
            <div>
              <h4>{data.pages.forget_pass_p.title}</h4>
              <p>{data.pages.forget_pass_p.desc}</p>
            </div>
            <Form.Group className="my-4" controlId="formBasicEmail">
              <Form.Label>{data.pages.forget_pass_p.email}</Form.Label>
              <Form.Control
                className="forget_pass_p-form-inputs"
                type="text"
                placeholder={data.pages.forget_pass_p.input1_placeholder}
                onChange={updateEmail}
                onBlur={() => setExplicitField("email", true)}
              />
              <Form.Text style={{ color: "red" }}>
                {joiErrorMessage(state.$errors.email)}
              </Form.Text>
            </Form.Group>

            <div className="forget_pass_p-form-btns d-flex align-items-center gap-3">
              <Button
                className=" w-100"
                variant="primary"
                type="submit"
                disabled={btnLoader ? true : false}
              >
                {data.pages.forget_pass_p.submit}
              </Button>
              <Button
                onClick={() => (window.location.href = "/")}
                className=" w-100"
                variant="primary"
                type="button"
              >
                {data.pages.forget_pass_p.back}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default ForgetPass;
